import React from 'react';
import {
  Formik,
  Field,
} from 'formik';
import i18n from 'i18next';

import * as Yup from 'yup';

import {
  Flex,
} from 'web-styled';
import {
  Modal,
  Button,
  TextField,
} from 'web-components';

type Props = {
  label: string;
  email: string;
  isOpen: boolean;
  appearance: string;
  buttonLabel: string;
  onSubmit: { (): void };
  onRequestClose: { (): void };
};

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Please enter a valid email')
    .required('Please enter a valid email'),
});

const InviteClient = ({
  label,
  email,
  buttonLabel,
  appearance,
  isOpen,
  onSubmit,
  onRequestClose,
}: Props) => (
  <Modal
    title={i18n.t('invite.client')}
    isOpen={isOpen}
    onRequestClose={onRequestClose}
  >
    <Formik
      initialValues={{
        email: email || '',
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({
        handleSubmit,
        isSubmitting,
        values,
      }) => (
        <Flex
          column
          width="100%"
          as="form"
          spacing={15}
          onSubmit={handleSubmit}
        >
          <Field
            autoFocus
            name="email"
            label={`${i18n.format(i18n.t('client'), 'cap')}'s email`}
            value={values.email}
            component={TextField}
          />
          <Flex
            width="100%"
            justify="flex-end"
            spacing={20}
          >
            <Button
              ghost
              appearance={appearance || 'primary'}
              type="submit"
              spacing="large"
              isLoading={isSubmitting}
              isDisabled={isSubmitting}
            >
              {buttonLabel}
            </Button>
          </Flex>
        </Flex>
      )}
    </Formik>
  </Modal>
);

export default InviteClient;
